var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fluid",class:{dark:_vm.dark}},[_c('h2',[_vm._v("Fluid Lines")]),_vm._m(0),_vm._l((_vm.items),function(i){return _c('div',{key:i,staticClass:"work"},[_c('img',{attrs:{"src":'./img/' + i.src}}),_c('h4',[_vm._v(_vm._s(i.txt))])])})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("2021"),_c('br'),_vm._v("Watercolour on paper (4K).")])
}]

export { render, staticRenderFns }